/* eslint-disable indent */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/camelcase */
import { Grid } from '@material-ui/core';
import i18n from 'i18n';
import { AuditLogsActions, AuditLogsResults } from 'modules/audit/interfaces';
import React from 'react';
import {
  generateDiffList,
  generateInfoText,
  isObjectEmpty,
  generatePublishText,
  getValueText,
} from './utils';
import { getFieldNameText } from '../utils';

interface LogsDetailsProps {
  auditLog: AuditLogsResults;
}

const LogsDetails = ({ auditLog }: LogsDetailsProps) => {
  const generateDetailsText = (data: AuditLogsResults): string => {
    if (isObjectEmpty(data?.details_json)) return i18n.t('NOT_ENOUGH_DATA_KEY');

    if (data?.action === AuditLogsActions.ACTION_UPDATE)
      return generateDiffList(data?.details_json);

    if (data?.action === AuditLogsActions.ACTION_PUBLISH)
      return generatePublishText(data?.details_json);

    return generateInfoText(data);
  };

  const generateContextText = (context: Record<string, string>): string => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { method, ...data } = context;

    if (isObjectEmpty(data)) {
      return i18n.t('NOT_ENOUGH_DATA_KEY');
    }
    let changesList = '';

    for (const [key, value] of Object.entries(data)) {
      if (key === 'permission') {
        return `${getFieldNameText(key)}: ${i18n.t(value.toUpperCase())}\n`;
      }

      changesList += `${getFieldNameText(key)}: ${getValueText(value)}\n`;
    }

    return changesList;
  };

  return (
    <>
      <Grid>{generateDetailsText(auditLog)}</Grid>
      <Grid>{generateContextText(auditLog?.context_json)}</Grid>
    </>
  );
};
export default LogsDetails;
